import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const SERVICE_NAME = 'wayste-frontend';

export function initDatadogRum(): void {
    if (import.meta.env.MODE === 'localhost') return;

    const applicationId = import.meta.env.VITE_DD_RUM_APPLICATION_ID;
    const clientToken = import.meta.env.VITE_DD_RUM_CLIENT_TOKEN;
    if (!applicationId || !clientToken) return;

    const apiUrl = import.meta.env.VITE_BASE_API_URL;
    const site = import.meta.env.VITE_DD_SITE ?? 'us5.datadoghq.com';

    datadogRum.init({
        applicationId,
        clientToken,
        site,
        service: SERVICE_NAME,
        env: import.meta.env.MODE,
        version: __APP_VERSION__,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: apiUrl ? [apiUrl] : undefined,
    });

    datadogLogs.init({
        clientToken,
        site,
        service: SERVICE_NAME,
        env: import.meta.env.MODE,
        version: __APP_VERSION__,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    });
}
